"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = {
  PAUSED: 'paused',
  PLAYING: 'playing',
  ENDED: 'ended'
};
exports.default = _default;